import { cn } from "@/lib/cn";

/**
 * Generic content card. The base building block above which Metric/Feature
 * cards are composed.
 */
export const Card = ({
  children,
  className,
  interactive = false,
  padding = "default",
  testId,
}) => {
  return (
    <div
      data-testid={testId || "card"}
      className={cn(
        "rounded-xl border border-border bg-card",
        interactive &&
          "transition-colors hover:bg-surface/40 hover:border-foreground/15",
        padding === "default" && "p-6",
        padding === "compact" && "p-4",
        padding === "lg" && "p-8",
        padding === "none" && "p-0",
        className
      )}
    >
      {children}
    </div>
  );
};

export const CardHeader = ({ children, className }) => (
  <div className={cn("mb-4 flex flex-col gap-1.5", className)}>{children}</div>
);

export const CardTitle = ({ children, className }) => (
  <h3 className={cn("text-base font-medium tracking-tight text-foreground", className)}>
    {children}
  </h3>
);

export const CardDescription = ({ children, className }) => (
  <p className={cn("text-sm leading-relaxed text-muted-foreground", className)}>
    {children}
  </p>
);

export default Card;
